import React from "react";

const handleAbmWithdrawals = (props) => {
  const options = [
    {
      text: 'Qu’est-ce que le service Comptant INTERAC?',
      handler: props.actionProvider.handleAbmWithdrawals1,
      id: 1,
    },
    {
      text: 'Une situation survenue à un guichet automatique bancaire (GAB) me préoccupe. Pouvez-vous m’aider?',
      handler: props.actionProvider.handleAbmWithdrawals2,
      id: 2
    },
    {
      text: 'La sécurité de Comptant INTERAC',
      handler: props.actionProvider.handleAbmWithdrawals3,
      id: 3
    },
    {
      text: 'Fonctionnement de Comptant INTERAC?',
      handler: props.actionProvider.handleAbmWithdrawals4,
      id: 4
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container requestmoney-products'>{optionsMarkup}</div>;
};

export default handleAbmWithdrawals;